// Toggle to false to hide prices across the website, or true to show them.
export const SHOW_PRICES = false;
